import type { accountMenu as en } from '@/i18n/locales/en/accountMenu';
import type { Translation } from '@/i18n/types';

export const accountMenu: Translation<typeof en> = {
  trigger: 'Conta',
  viewProfile: 'Ver perfil',
  roles: {
    admin: 'Administrador da plataforma',
    companyAdmin: 'Administrador da empresa',
    departmentAdmin: 'Administrador/treinador do departamento',
  },
  company: {
    label: 'Empresa',
    switchTo: 'Mudar para {{name}}',
  },
  accounts: {
    label: 'Outras contas',
    switchTo: 'Mudar para {{name}}',
    addAnother: 'Iniciar sessão com outra conta',
  },
  manage: 'Gerir',
  settings: 'Perfil da empresa',
  language: 'Idioma',
  theme: {
    label: 'Tema',
    light: 'Claro',
    dark: 'Escuro',
    system: 'Sistema',
  },
  signOut: 'Terminar sessão',
  signOutAll: 'Terminar sessão em todas as contas',
};
